import { NlpRule } from '@feedyou-ai/feedbot-schema'

export enum MatchExplanation {
  RULE_SINGLE_MATCH = 'RULE_SINGLE_MATCH',
  RULE_MULTI_MATCH = 'RULE_MULTI_MATCH',
  EXACT_SINGLE_MATCH = 'EXACT_SINGLE_MATCH',
  EXACT_MULTI_MATCH = 'EXACT_MULTI_MATCH',
  NLP_SINGLE_MATCH = 'NLP_SINGLE_MATCH',
  NLP_MULTI_MATCH = 'NLP_MULTI_MATCH',
  LLM_TEXT_RESPONSE = 'LLM_TEXT_RESPONSE',
  NO_MATCH = 'NO_MATCH',
  TRAINING = 'TRAINING',
  VULGARISM = 'VULGARISM',
  ERROR = 'ERROR',

  LEGACY__CHATGPT_TEXT_RESPONSE = 'LEGACY__CHATGPT_TEXT_RESPONSE'
}

export function verbalizeMatchExplanation(explanation: MatchExplanation) {
  switch (explanation) {
    case MatchExplanation.EXACT_SINGLE_MATCH:
      return 'exact single match'
    case MatchExplanation.EXACT_MULTI_MATCH:
      return 'exact multi match'
    case MatchExplanation.RULE_SINGLE_MATCH:
      return 'rule single match'
    case MatchExplanation.RULE_MULTI_MATCH:
      return 'rule multi match'
    case MatchExplanation.NLP_SINGLE_MATCH:
      return 'nlp single match'
    case MatchExplanation.NLP_MULTI_MATCH:
      return 'nlp multi match'
    case MatchExplanation.NO_MATCH:
      return 'no match'
    case MatchExplanation.TRAINING:
      return 'training'
    case MatchExplanation.VULGARISM:
      return 'vulgarism'
    default:
      return 'unknown'
  }
}

verbalizeMatchExplanation.mode = (explanation: MatchExplanation) => {
  switch (explanation) {
    case MatchExplanation.EXACT_SINGLE_MATCH:
    case MatchExplanation.EXACT_MULTI_MATCH:
      return 'exact nlp'
    case MatchExplanation.RULE_SINGLE_MATCH:
    case MatchExplanation.RULE_MULTI_MATCH:
      return 'rule'
    case MatchExplanation.NLP_SINGLE_MATCH:
    case MatchExplanation.NLP_MULTI_MATCH:
      return 'nlp'
    case MatchExplanation.NO_MATCH:
      return 'no match'
    case MatchExplanation.TRAINING:
      return 'training'
    case MatchExplanation.VULGARISM:
      return 'vulgarism'
    default:
      return 'unknown match mechanism'
  }
}

export interface RecognizerIntent {
  intent: string
  score: number
  name?: string
  answer?: string
  priority?: boolean
  displayName?: string
  matchedRule?: NlpRule | undefined
  model?: { id: string; provider?: string }
}
